import { render } from "preact";
import { App } from "./App.tsx";
import { loadBrandStyles } from "./brand.ts";
import { config } from "./config.ts";
import { Callback } from "./pages/Callback.tsx";
import { Library } from "./pages/Library.tsx";
import { OpenError } from "./pages/OpenError.tsx";
import { ReadBook } from "./pages/ReadBook.tsx";
import { parseOpenParams } from "./params.ts";
import { route } from "./route.ts";
import "@fontsource-variable/cabin";
import "./styles/reader.css";
import "./styles/pages.css";

// Origines autorisées pour les manifests (serveur de publications). Vide = toutes (dev).
const allowedOrigins = (import.meta.env.VITE_MANIFEST_ORIGINS ?? "")
  .split(",")
  .map((s: string) => s.trim())
  .filter(Boolean);

const root = document.getElementById("app")!;
const current = route(window.location.pathname, window.location.search);

switch (current.kind) {
  case "callback":
    await loadBrandStyles(config.brand);
    render(<Callback />, root);
    break;
  case "read":
    await loadBrandStyles(config.brand);
    render(<ReadBook bookId={current.bookId} openChat={current.chat} />, root);
    break;
  case "open": {
    // Lien direct vers un manifest (extrait depuis une fiche produit).
    const result = parseOpenParams(window.location.search, allowedOrigins, window.location.hash);
    // Le jeton du chatbot ne reste pas dans la barre d'adresse ni dans l'historique.
    if (window.location.hash) history.replaceState(null, "", window.location.pathname + window.location.search);
    await loadBrandStyles(result.ok ? result.params.brand : config.brand);
    render(result.ok ? <App params={result.params} /> : <OpenError error={result.error} />, root);
    break;
  }
  case "library":
    await loadBrandStyles(config.brand);
    render(<Library />, root);
    break;
}
